import React from 'react';

const safePct = v => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };
const META = 90;

const colorSem = v => v >= META ? '#28a745' : v >= 80 ? '#fd7e14' : '#dc3545';
const labelSem = v => v >= META ? 'Cumple' : v >= 80 ? 'En riesgo' : 'No cumple';
const labelTema = t => t === 'DOCENTE' ? 'Docente' : t === 'TUTOR' ? 'Tutor' : (t || '—');

const ResultadoCalidad = ({ calidad }) => {
  if (!calidad || calidad.length === 0)
    return <p className="text-muted mb-0">No hay datos de calidad para el período seleccionado.</p>;

  return (
    <>
      {calidad.map((proyecto, j) => {
        const items = proyecto.datos || [];
        const avgPct = items.length
          ? Math.round(items.reduce((s, d) => s + safePct(d.porcentaje_mayor), 0) / items.length)
          : 0;
        const col = colorSem(avgPct);

        return (
          <div key={j} className={j < calidad.length - 1 ? 'mb-4' : ''}>
            {/* Encabezado del proyecto */}
            <div
              className="d-flex align-items-center justify-content-between p-2 mb-2"
              style={{ backgroundColor: '#f8f9fa', borderRadius: 6, borderLeft: `4px solid ${col}` }}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{proyecto.nombre_proyecto}</div>
                <small className="text-muted">
                  {proyecto.fecha_inicio} — {proyecto.fecha_fin}
                </small>
              </div>
              <div className="text-right">
                <div style={{ fontWeight: 700, fontSize: 22, color: col }}>{avgPct}%</div>
                <span style={{
                  fontSize: 11, fontWeight: 600, color: col,
                  backgroundColor: `${col}15`, padding: '2px 10px', borderRadius: 20,
                }}>
                  {labelSem(avgPct)}
                </span>
              </div>
            </div>

            {/* Tabla de sesiones */}
            {items.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered mb-0" style={{ fontSize: 13 }}>
                  <thead className="thead-light">
                    <tr>
                      <th>Sesión / Evaluado</th>
                      <th className="text-center" style={{ width: 80 }}>Meta</th>
                      <th className="text-center" style={{ width: 140 }}>Calificación</th>
                      <th className="text-center" style={{ width: 100 }}>Brecha</th>
                      <th className="text-center" style={{ width: 110 }}>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((dato, i) => {
                      const v    = safePct(dato.porcentaje_mayor);
                      const col  = colorSem(v);
                      const brecha = safePct(dato.brecha) || parseFloat((Math.max(0, META - v)).toFixed(1));
                      return (
                        <tr key={i}>
                          <td className="align-middle">{labelTema(dato.tema)}</td>
                          <td className="text-center align-middle text-muted">{META}%</td>
                          <td className="text-center align-middle">
                            <div style={{ fontWeight: 700, fontSize: 17, color: col }}>{v}%</div>
                            <div className="progress mt-1" style={{ height: 4, borderRadius: 2 }}>
                              <div
                                className="progress-bar"
                                style={{ width: `${Math.min(100, v)}%`, backgroundColor: col, borderRadius: 2 }}
                              />
                            </div>
                          </td>
                          <td className="text-center align-middle text-muted">{brecha}%</td>
                          <td className="text-center align-middle">
                            <span style={{
                              fontSize: 11, fontWeight: 600, color: col,
                              backgroundColor: `${col}15`, padding: '2px 8px', borderRadius: 20,
                            }}>
                              {labelSem(v)}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted mb-0" style={{ fontSize: 13 }}>Sin datos de sesiones para este producto.</p>
            )}
          </div>
        );
      })}
    </>
  );
};

export default ResultadoCalidad;
